import React, {
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";

import "admin-lte/dist/css/adminlte.min.css";
import "../../../assets/AdminCss/dashboard.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faCaretLeft,
} from "@fortawesome/free-solid-svg-icons";

import {
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";

import { createPortal } from "react-dom";

import { AuthContext } from "../../../context/Authcontext";
import api from "../../../utils/api";


const AdminSidebar = ({
  isSidebarOpen,
  toggleSidebar,
  isMobile,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const asideRef = useRef(null);

  const [key, setKey] = useState({
    name: "",
    role: "",
  });

  const [isPagesOpen, setIsPagesOpen] = useState({});

  /* =========================
     COLLAPSED SIDEBAR STATES
  ========================= */

  const [hoveredMenu, setHoveredMenu] = useState(null);

  const [flyoutPosition, setFlyoutPosition] = useState({
    top: 0,
    left: 0,
  });

  const { getRoles } = useContext(AuthContext);


  /* =========================
     SIDEBAR MENU
  ========================= */

  const [sideListItems, setSideListItems] = useState([
    {
      Name: "User",
      iconName: "nav-icon fa fa-user",
      List: [],
      isAllowed: false,
    },

    {
      Name: "Add Matches",
      url: "/admin/matches",
      iconName: "nav-icon fa fa-calendar",
      isAllowed: false,
    },

    {
      Name: "Manage Sports Results",
      url: "/admin/manage_market",
      iconName: "nav-icon fa fa-sliders",
      isAllowed: false,
    },

    {
      Name: "Casino-history",
      url: "/admin/casinohistory",
      iconName: "nav-icon fa fa-dice",
      isAllowed: false,
    },

    {
      Name: "Slider",
      url: "/admin/slider",
      iconName: "nav-icon fa fa-image",
      isAllowed: false,
    },

    {
      Name: "Settlement",
      url: "/admin/settlement",
      iconName: "nav-icon fa fa-gift",
      isAllowed: false,
    },

    {
      Name: "Roles",
      url: "/admin/roles",
      iconName: "nav-icon fa fa-users-cog",
      isAllowed: false,
    },

    {
      Name: "Delete Bets",
      url: "/admin/getDeleteBets",
      iconName: "nav-icon fa fa-trash",
      isAllowed: false,
    },

    {
      Name: "Reports",
      iconName: "nav-icon fa fa-chart-bar",

      List: [
        {
          Name: "My Bets",
          url: "/admin/betHistory",
          iconName: "nav-icon fa fa-list-alt",
          isAllowed: false,
        },

        {
          Name: "Match History",
          url: "/admin/matchHistoryManage",
          iconName: "nav-icon fa fa-line-chart",
          isAllowed: false,
        },

        {
          Name: "settlement history",
          url: "/admin/settleHistory",
          iconName: "nav-icon fa fa-balance-scale",
          isAllowed: false,
        },

        {
          Name: "Profit Loss",
          url: "/admin/profitloss",
          iconName: "nav-icon fa fa-line-chart",
          isAllowed: false,
        },

        {
          Name: "Super Admin Chip",
          url: "/admin/adminChip",
          iconName: "nav-icon fa fa-diamond",
          isAllowed: false,
        },

        {
          Name: "User Chip",
          url: "/admin/userChip",
          iconName: "nav-icon fa fa-circle",
          isAllowed: false,
        },

        {
          Name: "week-report",
          url: "/admin/weekReport",
          iconName: "nav-icon fa fa-calendar",
          isAllowed: false,
        },

        {
          Name: "Fancy History",
          url: "/admin/fancyHistory",
          iconName: "nav-icon fa fa-history",
          isAllowed: false,
        },
      ],

      isAllowed: false,
    },

    {
      Name: "Settings",
      url: "/admin/settings",
      iconName: "nav-icon fa fa-cog",
      isAllowed: false,
    },
  ]);


  /* =========================
     FLYOUT POSITION
  ========================= */

  const getFlyoutLeft = () => {
    if (!asideRef.current) {
      return isSidebarOpen ? 250 : 65;
    }

    const rect = asideRef.current.getBoundingClientRect();

    return rect.right;
  };


  /* =========================
     LOGOUT
  ========================= */

  const handleLogout = () => {
    navigate("/admin/login");

    localStorage.removeItem("admin");
    localStorage.removeItem("role");
  };


  /* =========================
     FETCH CURRENT USER
  ========================= */

  const fetchUser = async () => {
    const auth = localStorage.getItem("admin");

    try {
      const response = await api.get(
        "/api/webapi/loggedUser",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      const name =
        response.data.username.username;

      const role =
        response?.data.username.role;

      setKey({
        name,
        role,
      });
    } catch (err) {
      console.log("err", err);
    }
  };


  /* =========================
     MENU CLICK
  ========================= */

  const handleClick = (list) => {
    if (list.url) {
      navigate(list.url);

      if (isMobile) {
        toggleSidebar();
      }

      setHoveredMenu(null);

    } else if (list.List) {
      if (!isSidebarOpen) {
        // Collapsed sidebar: submenu only opens via hover flyout
        return;
      }

      setIsPagesOpen((prev) => ({
        ...prev,
        [list.Name]: !prev[list.Name],
      }));
    }
  };


  /* =========================
     FETCH PERMISSIONS
  ========================= */

  const fetchRoles = async () => {
    const auth = localStorage.getItem("admin");
    const role = localStorage.getItem("role");

    try {
      const roles = await getRoles(
        auth,
        role
      );

      const permitRole = roles[0];

      if (!permitRole) return;

      const key = Object.keys(permitRole);

      setKey((prev) => ({
        ...prev,
        role: key[0],
      }));

      const arr = permitRole[key];

      const allowedKeys = [];
      const allowedValues = [];

      arr.map((item) => {
        const k = Object.keys(item);
        const values = Object.values(item);

        allowedKeys.push(k[0]);

        allowedValues.push(values[0]);
      });

      const allowed = [];

      allowedValues.forEach((allow) => {
        if (Array.isArray(allow)) {
          allow.forEach((value) =>
            allowed.push(
              value.toLowerCase()
            )
          );
        }
      });

      setSideListItems((prevItems) =>
        prevItems.map((item) => ({
          ...item,

          isAllowed:
            allowedKeys.includes(
              item.Name.toLowerCase()
            ),

          List: item.List
            ? item.List.map(
                (subItem) => ({
                  ...subItem,

                  isAllowed:
                    allowed.includes(
                      subItem.Name.toLowerCase()
                    ),
                })
              )
            : item.List,
        }))
      );

    } catch (err) {
      console.log("erd", err);
    }
  };


  /* =========================
     GET ROLE NAMES
  ========================= */

  const roleName = async () => {
    const auth = localStorage.getItem("admin");

    try {
      const response =
        await api.post(
          "/api/webapi/admin/Rolelist",
          {},
          {
            headers: {
              Accept:
                "application/json",

              Authorization: `${auth}`,
            },
          }
        );

      const fullRoles =
        response.data.data;

      let arr = [];

      fullRoles?.map((full) => {
        const keyy =
          Object.keys(full);

        arr.push(keyy[0]);
      });

      return arr;

    } catch (err) {
      console.log("err", err);

      return [];
    }
  };


  /* =========================
     UPDATE SIDEBAR USING ROLES
  ========================= */

  const updateSidebarWithRoles = (
    roleNames
  ) => {

    const roleHierarchy = [
      "super admin",
      "Admin",
      "Super master",
      "Master",
      "Agent",
      "User",
    ];

    const normalRoles =
      roleNames.map((role) =>
        role.toLowerCase()
      );

    const hierarchy =
      roleHierarchy.map((role) =>
        role.toLowerCase()
      );

    const verified =
      hierarchy.filter((hier) =>
        normalRoles.includes(hier)
      );

    setSideListItems(
      (prevItems) => {

        return prevItems?.map(
          (item) => {

            if (item.Name === "User") {

              return {
                ...item,

              List: verified.map((itemName) => ({
  Name: itemName,
  url: `/admin/${itemName
    .toLowerCase()
    .replace(/\s+/g, "")}`,
  iconName: "nav-icon fa fa-user",
  isAllowed: true,
})),
              };
            }

            return item;
          }
        );
      }
    );
  };


  /* =========================
     INITIALIZE SIDEBAR
  ========================= */

  useEffect(() => {

    const initializeSidebar =
      async () => {

        try {

          const roleNames =
            await roleName();

          updateSidebarWithRoles(
            roleNames
          );

          await fetchUser();

        } catch (error) {

          console.error(
            "Error initializing sidebar:",
            error
          );
        }
      };

    initializeSidebar();

    fetchRoles();

  }, []);


  /* =========================
     OPEN ACTIVE PARENT
  ========================= */

  useEffect(() => {

    const currentPath =
      location.pathname;

    setSideListItems(
      (prevItems) => {

        const openPages = {};

        prevItems.forEach(
          (item) => {

            if (item.List) {

              const matched =
                item.List.some(
                  (sub) =>
                    sub.url ===
                    currentPath
                );

              if (matched) {
                openPages[
                  item.Name
                ] = true;
              }
            }
          }
        );

        setIsPagesOpen(
          openPages
        );

        return prevItems;
      }
    );

  }, [location.pathname]);


  /* =========================
     KEEP PARENT OPEN
  ========================= */

  useEffect(() => {

    const currentPath =
      location.pathname;

    setIsPagesOpen(
      (prevOpen) => {

        const updatedOpen = {
          ...prevOpen,
        };

        sideListItems.forEach(
          (item) => {

            if (item.List) {

              const matched =
                item.List.some(
                  (sub) =>
                    sub.url ===
                    currentPath
                );

              if (matched) {

                updatedOpen[
                  item.Name
                ] = true;
              }
            }
          }
        );

        return updatedOpen;
      }
    );

  }, [
    location.pathname,
    sideListItems,
  ]);


  /* =========================
     CLOSE FLYOUT WHEN SIDEBAR
     OPENS
  ========================= */

  useEffect(() => {

    if (isSidebarOpen) {
      setHoveredMenu(null);
    }

  }, [isSidebarOpen]);


  /* =========================
     DASHBOARD ACCESS
  ========================= */

  const isDashboardAllowed =
    true;


  /* =========================
     RENDER
  ========================= */

  return (
    <>
      {/* =========================
          MOBILE OVERLAY
      ========================= */}

      {isMobile &&
        isSidebarOpen && (
          <div
            className="sidebar-overlay"
            onClick={toggleSidebar}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor:
                "rgba(0,0,0,0.4)",
              zIndex: 1040,
            }}
          />
        )}


      {/* =========================
          SIDEBAR
      ========================= */}

      <aside
        ref={asideRef}
        className={`main-sidebar sidebar-light-primary fs-6 sidebar-scroll-hidden ${
          isSidebarOpen
            ? "sidebar-open"
            : "sidebar-collapse"
        }`}
        style={{
          zIndex: 1050,
          borderRight:
            "1px solid #14b09d",
          transition:
            "width 0.3s ease-in-out, transform 0.3s ease-in-out",
          position: "fixed",
          top: 0,
          height: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          background: "#DFE5E5",
          /* Explicit width so collapsed state can never
             be squeezed/hidden by an external CSS clash */
          width: isSidebarOpen ? "250px" : "65px",
          minWidth: isSidebarOpen ? "250px" : "65px",
          maxWidth: isSidebarOpen ? "250px" : "65px",

          transform:
            window.innerWidth <= 768 && !isSidebarOpen
              ? "translateX(-100%)"
              : "translateX(0)",
        }}
      >

        {/* =========================
            BRAND / LOGO
        ========================= */}

        <p
          className="
            brand-link
            align-items-center
            brand-link
            mb-0
            pb-0
            pt-1
            d-flex
            justify-content-start
            gap-3
            ml-0
            cursor-pointer
          "
          style={{backgroundColor: "rgb(7 143 202)"}}
        >

          <Link
            data-target="nav-mobile"
            className="sidenav-trigger1"
            onClick={toggleSidebar}
          >
            <i className="fa-solid fa-xmark"></i>
          </Link>


          {isSidebarOpen && (
            <span
              className="
                brand-text
                font-weight-light
                text-wrap
              "
            >

              <img
                src="/assets/all_images/header/alllogo.png"
                alt="Logo"
                style={{
                  width: "120px",
                }}
                onClick={() =>
                  navigate(
                    "/admin/Profile"
                  )
                }
              />

            </span>
          )}

        </p>


        {/* =========================
            SIDEBAR CONTENT
        ========================= */}

        <div
          className="sidebar"
          style={{
            height: "auto",
            width: "100%",
            boxSizing: "border-box",
          }}
        >

          <nav className="mt-2">

            <ul
              className="
                nav
                nav-pills
                nav-sidebar
                flex-column
              "
              role="menu"
              style={{
                width: "100%",
                paddingLeft: 0,
                marginBottom: 0,
              }}
            >

              {/* =========================
                  DASHBOARD
              ========================= */}

              {isDashboardAllowed && (
                <li
                  className={`nav-item ${
                    location.pathname ===
                    "/admin/dashboard"
                      ? "active-nav"
                      : ""
                  }`}

                  onClick={() =>
                    navigate(
                      "/admin/dashboard"
                    )
                  }

                  onMouseEnter={(e) => {

                    if (!isSidebarOpen) {

                      const rect =
                        e.currentTarget.getBoundingClientRect();

                      setHoveredMenu(
                        "Dashboard"
                      );

                      setFlyoutPosition({
                        top: rect.top,

                        left:
                          getFlyoutLeft(),
                      });
                    }
                  }}

                  onMouseLeave={() => {

                    if (!isSidebarOpen) {
                      setHoveredMenu(null);
                    }

                  }}
                >

                  <Link
                    to="#"
                    className={`align-items-center d-flex nav-link gap-2 ${
                      !isSidebarOpen &&
                      hoveredMenu ===
                        "Dashboard"
                        ? "flyout-hover-active"
                        : ""
                    }`}
                  >

                    <i
                      className="
                        nav-icon
                        bx
                        bx-home-circle
                      "
                      style={{
                        color: "#000000",
                      }}
                    />

                    {isSidebarOpen && (
                      <p
                        className="
                          text-black
                          font-weight-normal
                          mb-0
                        "
                      >
                        Dashboard
                      </p>
                    )}

                  </Link>


                  {/* Dashboard Flyout */}

                  {!isSidebarOpen &&
                    hoveredMenu ===
                      "Dashboard" &&
                    createPortal(

                      <div
                        className="sidebar-flyout"

                        style={{
                          position:
                            "fixed",

                          top: `${flyoutPosition.top}px`,

                          left: `${flyoutPosition.left}px`,
                        }}

                        onMouseEnter={() =>
                          setHoveredMenu(
                            "Dashboard"
                          )
                        }

                        onMouseLeave={() =>
                          setHoveredMenu(
                            null
                          )
                        }
                      >

                        <div
                          className="sidebar-flyout-item"
                          style={{
                            cursor:
                              "default",
                          }}
                        >
                          <span>
                            Dashboard
                          </span>
                        </div>

                      </div>,

                      document.body
                    )}

                </li>
              )}


              {/* =========================
                  DYNAMIC MENU
              ========================= */}

              {sideListItems
                .filter((list) => {

               const allowedChildren =
  list.List
    ? list.List.filter(
        (subItem) => subItem.isAllowed
      )
    : [];
                  const parentAllowed =
                    list.isAllowed;

                  return (
                    parentAllowed ||
                    allowedChildren.length >
                      0
                  );
                })

                .map(
                  (list, index) => {

                    const allowedChildren =
                      list.List
                        ? list.List.filter(
                            (subItem) =>
                              subItem.isAllowed
                          )
                        : [];

                    const hasChildren =
                      allowedChildren.length >
                      0;


                    return (
                      <li
                        key={index}

                        className={`nav-item ${
                          location.pathname ===
                          list.url
                            ? "active-nav"
                            : ""
                        }`}

                        onClick={() =>
                          handleClick(
                            list
                          )
                        }


                        /* =========================
                           HOVER OPEN FLYOUT
                        ========================= */

                        onMouseEnter={(e) => {

                          if (
                            !isSidebarOpen
                          ) {

                            const rect =
                              e.currentTarget.getBoundingClientRect();

                            setHoveredMenu(
                              list.Name
                            );


                            const estimatedHeight =
                              hasChildren
                                ? 46 +
                                  allowedChildren.length *
                                    42 +
                                  16
                                : 42;


                            const maxTop =
                              window.innerHeight -
                              estimatedHeight -
                              8;


                            setFlyoutPosition({
                              top:
                                Math.max(
                                  8,
                                  Math.min(
                                    rect.top,
                                    maxTop
                                  )
                                ),

                              left:
                                getFlyoutLeft(),
                            });
                          }

                        }}


                        onMouseLeave={() => {

                          if (
                            !isSidebarOpen
                          ) {

                            setHoveredMenu(
                              null
                            );
                          }

                        }}
                      >

                        {/* =========================
                            PARENT MENU
                        ========================= */}

                        <Link
                          to="#"

                          className={`align-items-center d-flex nav-link gap-2 ${
                            !isSidebarOpen &&
                            hoveredMenu ===
                              list.Name
                              ? "flyout-hover-active"
                              : ""
                          }`}
                        >

                          <i
                            className={`${list.iconName} fs-5`}
                            style={{
                              color:
                                "#000000",
                            }}
                          />


                          {isSidebarOpen && (
                            <p
                              className="
                                text-black
                                font-weight-normal
                                mb-0
                              "
                            >
                              {list.Name}
                            </p>
                          )}


                          {/* Dropdown Arrow */}

                          {hasChildren && isSidebarOpen && (
                            <FontAwesomeIcon
                              icon={
                                isPagesOpen[
                                  list.Name
                                ]
                                  ? faCaretDown
                                  : faCaretLeft
                              }
                              className="
                                dropdown-icon
                                ms-auto
                              "
                            />
                          )}

                        </Link>


                        {/* =========================
                            CHILDREN
                        ========================= */}

                        {hasChildren &&
                          isSidebarOpen &&
                          isPagesOpen[
                            list.Name
                          ] &&
                          allowedChildren.map(
                            (
                              uList,
                              id
                            ) => (

                              <ul
                                key={id}
                                className="
                                  nav
                                  nav-treeview
                                  pl-3
                                  show
                                "
                              >

                                <li
                                  className={`nav-item ${
                                    location.pathname ===
                                    uList.url
                                      ? "active-nav"
                                      : ""
                                  }`}

                                  onClick={(
                                    e
                                  ) => {

                                    e.stopPropagation();

                                    navigate(
                                      uList.url
                                    );

                                    if (
                                      isMobile
                                    ) {
                                      toggleSidebar();
                                    }
                                  }}
                                >

                                  <Link
                                    to="#"
                                    className="
                                      align-items-center
                                      d-flex
                                      nav-link
                                    "
                                  >

                                    <i
                                      className={`${
                                        uList.iconName ||
                                        "nav-icon bx bx-right-arrow-alt"
                                      } fs-6`}
                                    />

                                    <p
                                      className="
                                        text-black
                                        font-weight-normal
                                        mb-0
                                      "
                                    >
                                      {
                                        uList.Name
                                      }
                                    </p>

                                  </Link>

                                </li>

                              </ul>

                            )
                          )}


                        {/* =========================
                            COLLAPSED FLYOUT
                        ========================= */}

                        {!isSidebarOpen &&
                          hoveredMenu ===
                            list.Name &&
                          createPortal(

                            <div
                              className="sidebar-flyout"

                              style={{
                                position:
                                  "fixed",

                                top: `${flyoutPosition.top}px`,

                                left: `${flyoutPosition.left}px`,
                              }}

                              onMouseEnter={() =>
                                setHoveredMenu(
                                  list.Name
                                )
                              }

                              onMouseLeave={() =>
                                setHoveredMenu(
                                  null
                                )
                              }
                            >

                              {hasChildren ? (
                                <>

                                  {/* Flyout Title */}

                                  <div
                                    className="
                                      sidebar-flyout-title
                                    "
                                  >
                                    {
                                      list.Name
                                    }
                                  </div>


                                  {/* Flyout Children */}

                                  {allowedChildren.map(
                                    (
                                      uList,
                                      id
                                    ) => (

                                      <Link
                                        key={id}
                                        to={
                                          uList.url
                                        }

                                        className="
                                          sidebar-flyout-item
                                        "

                                        onClick={() => {

                                          navigate(
                                            uList.url
                                          );

                                          setHoveredMenu(
                                            null
                                          );

                                          if (
                                            isMobile
                                          ) {
                                            toggleSidebar();
                                          }
                                        }}
                                      >

                                        <i
                                          className={`${
                                            uList.iconName ||
                                            "nav-icon bx bx-right-arrow-alt"
                                          }`}
                                        />

                                        <span>
                                          {
                                            uList.Name
                                          }
                                        </span>

                                      </Link>

                                    )
                                  )}

                                </>
                              ) : (

                                /* =========================
                                   SINGLE ITEM FLYOUT
                                ========================= */

                                <div
                                  className="
                                    sidebar-flyout-item
                                  "

                                  style={{
                                    cursor:
                                      "default",
                                  }}
                                >

                                  <span>
                                    {
                                      list.Name
                                    }
                                  </span>

                                </div>

                              )}

                            </div>,

                            document.body
                          )}

                      </li>
                    );
                  }
                )}


              {/* =========================
                  LOGOUT
              ========================= */}

              <li
                className="nav-item"

                onClick={
                  handleLogout
                }


                onMouseEnter={(e) => {

                  if (
                    !isSidebarOpen
                  ) {

                    const rect =
                      e.currentTarget.getBoundingClientRect();

                    setHoveredMenu(
                      "Log Out"
                    );

                    setFlyoutPosition({
                      top: rect.top,
                      left:
                        getFlyoutLeft(),
                    });
                  }

                }}


                onMouseLeave={() => {

                  if (
                    !isSidebarOpen
                  ) {

                    setHoveredMenu(
                      null
                    );
                  }

                }}
              >

                <Link
                  to="#"

                  className={`align-items-center d-flex nav-link gap-2 ${
                    !isSidebarOpen &&
                    hoveredMenu ===
                      "Log Out"
                      ? "flyout-hover-active"
                      : ""
                  }`}
                >

                  <i
                    className="
                      nav-icon
                      fa
                      fa-sign-out
                    "
                  />

                  {isSidebarOpen && (
                    <p
                      className="
                        text-black
                        font-weight-normal
                        mb-0
                      "
                    >
                      Log Out
                    </p>
                  )}

                </Link>


                {/* =========================
                    LOGOUT FLYOUT
                ========================= */}

                {!isSidebarOpen &&
                  hoveredMenu ===
                    "Log Out" &&
                  createPortal(

                    <div
                      className="sidebar-flyout"

                      style={{
                        position:
                          "fixed",

                        top: `${flyoutPosition.top}px`,

                        left: `${flyoutPosition.left}px`,
                      }}

                      onMouseEnter={() =>
                        setHoveredMenu(
                          "Log Out"
                        )
                      }

                      onMouseLeave={() =>
                        setHoveredMenu(
                          null
                        )
                      }
                    >

                      <div
                        className="
                          sidebar-flyout-item
                        "

                        style={{
                          cursor:
                            "default",
                        }}
                      >

                        <span>
                          Log Out
                        </span>

                      </div>

                    </div>,

                    document.body
                  )}

              </li>

            </ul>

          </nav>

        </div>

      </aside>
    </>
  );
};


export default AdminSidebar;